<p-dialog
  [(visible)]="showDossierUploadDialog"
  [header]="translationKeys.uploadProductDialogComponent.html.dialogTitle | translate"
  [style]="{ width: '90vw' }"
  (onHide)="closeDossierUploadDialog()"
  [modal]="true"
  [appendTo]="'body'"
  [maximizable]="true"
  [styleClass]="'upload-product-dialog'"
>
  <scip-dossier-upload-table #dossierTable [dossierData]="dossierData" [avanoLoadingIndicator]="blockingIdentifier"></scip-dossier-upload-table>
  <div class="form-field">
    <label>{{ translationKeys.uploadProductDialogComponent.html.otherName | translate }}</label>
    <p-autoComplete [formControl]="otherArticleNames" name="otherName" avanoSelectFieldMultiple (selectButtonClick)="openOtherNameDialog()">
      <ng-template let-otherName pTemplate="selectedItem">
        <span class="p-autocomplete-token-label"> {{ otherName | otherNameLabel | translate }}: {{ otherName.text }} </span>
      </ng-template>
    </p-autoComplete>
  </div>
  <div class="form-field">
    <label for="default_organization">
      {{ translationKeys.uploadProductDialogComponent.html.defaultOrganization | translate }}
      <avano-required-icon></avano-required-icon>
    </label>
    <p-autoComplete
      id="default_organization"
      [field]="'name'"
      [suggestions]="organizationsSuggestions"
      (completeMethod)="filterDossierDefaultOrganizations($event)"
      [dropdown]="true"
      [forceSelection]="true"
      [appendTo]="'body'"
      [formControl]="selectedOrganization"
      [avanoValidationErrorSupport]="selectedOrganization"
      [avanoValidationErrorLabel]="translationKeys.uploadProductDialogComponent.html.defaultOrganization | translate"
    >
      <ng-template let-org pTemplate="item">{{ org.name }}</ng-template>
    </p-autoComplete>
    <span class="error-message" *ngIf="selectedOrganization.value && !selectedOrganization.value?.verified">
      {{ translationKeys.uploadProductDialogComponent.html.notVerifyOrganization | translate }}
    </span>
    <span class="error-message" *ngIf="selectedOrganization.value && selectedOrganization.value?.verified && selectedOrganization.value?.validationErrors">
      {{ translationKeys.uploadProductDialogComponent.html.verifyFailOrganization | translate }}
    </span>
    <span class="error-message" *ngIf="!selectedOrganization.valid && selectedOrganization.touched">
      {{ translationKeys.commonTranslationKey.validation.error.required.selection | translate }}
    </span>
  </div>
  <div class="form-field">
    <avano-radio-checkbox-group [label]="translationKeys.uploadProductDialogComponent.html.dossierType | translate" [alignHorizontal]="true">
      <avano-radiobutton *ngFor="let singleDossierType of allDossierTypes" [value]="singleDossierType.key" [formControl]="selectedRequestType">{{
        singleDossierType.name | translate
      }}</avano-radiobutton>
    </avano-radio-checkbox-group>
  </div>
  <div class="form-field">
    <avano-checkbox [value]="true" *ngIf="allowForceResubmission" [(ngModel)]="forceResubmission" [binary]="true" [disabled]="false">
      {{ translationKeys.uploadProductDialogComponent.html.forceResubmission | translate }}
    </avano-checkbox>
  </div>
  <ng-template pTemplate="footer">
    <button
      type="button"
      avanoButton
      [label]="translationKeys.commonTranslationKey.btn.cancel | translate"
      [icon]="'icon-content-cancel'"
      (click)="closeDossierUploadDialog()"
    ></button>
    <button
      type="button"
      avanoButton
      [buttonType]="'callToAction'"
      [label]="translationKeys.uploadProductDialogComponent.html.buttons.upload | translate"
      [icon]="'icon-content-check'"
      [disabled]="!selectedOrganization.valid || !dossierTable.isValid"
      (click)="uploadDossiers()"
    ></button>
    <button
      *ngIf="validationErrors?.length > 0"
      type="button"
      avanoButton
      [icon]="'icon-content-error'"
      [label]="translationKeys.commonTranslationKey.btn.error | translate: { count: validationErrors.length }"
      [buttonType]="'error'"
      [avanoErrorsPopover]="validationErrors"
    ></button>
  </ng-template>
</p-dialog>

<scip-other-name-dialog
  *ngIf="displayOtherNameSelection"
  [otherNames]="otherArticleNames.value"
  (saveEvent)="saveOtherName($event)"
  (cancelEvent)="closeOtherNameDialog()"
></scip-other-name-dialog>
